import { Vue, newVue, initVue } from '@/config/vue'

initVue({
  controller: 'quiz',
  init() {
    const Quiz = Vue.component('quiz', () => import(/* webpackChunkName: "quiz" */ './Quiz.vue'))
    newVue({
      render: h => h(Quiz),
      mount: '#quiz',
    })
  },
})
